import { render, staticRenderFns } from "./ForumResponseHeader.vue?vue&type=template&id=5e6ef308&scoped=true"
import script from "./ForumResponseHeader.vue?vue&type=script&lang=js"
export * from "./ForumResponseHeader.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseHeader.vue?vue&type=style&index=0&id=5e6ef308&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6ef308",
  null
  
)

export default component.exports